/**
 * @features/dashboard/components/widgets/StatCard.jsx
 * ---------------------------------------------------
 * Compact metric card. Used by every role dashboard's top row.
 *
 *   <StatCard label="Saved" value={12} icon={Heart} trend="+3" />
 *
 * Skeleton fallback: `<StatCardSkeleton/>` already exists in
 * `components/Skeletons.jsx` — use that during data load.
 */

import React from "react";

export function StatCard({ label, value, icon: Icon, trend, hint, testid }) {
  return (
    <div
      className="bg-white border border-[#E4E4E7] rounded-sm p-4"
      data-testid={testid || `stat-card-${(label || "x").toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="text-[11px] uppercase tracking-[0.12em] text-[#71717A] font-semibold">
          {label}
        </div>
        {Icon ? <Icon size={14} className="text-[#A1A1AA]" /> : null}
      </div>
      <div className="mt-1.5 flex items-baseline gap-2">
        <div className="font-heading text-[22px] sm:text-[24px] font-semibold text-[#09090B] leading-none">
          {value ?? "—"}
        </div>
        {trend ? (
          <div className="text-[11px] text-[#15803D] font-semibold">{trend}</div>
        ) : null}
      </div>
      {hint ? <div className="text-[11px] text-[#A1A1AA] mt-1.5">{hint}</div> : null}
    </div>
  );
}
